//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO OS BOTÕES COM AS OPÇÕES DE             //   
//  COMPRA NOS CARDS DE PRODUTOS NÁ PÁGINA HOME         //   
//                                                      //   
//  FUNCIONALIDADE: REALIZAR O PAGAMENTO DO PEDIDO      //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/mock_picture.js                         //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import api from "../services/api";

function CarrinhoButtonPqn(props) {
    var carrinho = ''
    var id_produto = props.props.props.id

    for(var i = 0; i<props.props.prods_car.length; i++){  // PARA CADA ITEM NA LISTA DE NOMES DE PRODUTOS NO CARRINHO
        try{  // VE SE O ITEM TAMBÉM ESTÁ NA LISTA DE DETALHES DOS PRODUTOS NO CARRINHO
            var id = props.props.car[i].id
            var produto = props.props.car[i][id]
            
            if(produto.carrinho === 0){  // SE ESTIVER NO CARRINHO COM QUANTIDADE ZERO
                props.props.car.splice(i, 1)  // REMOVE DO CARRINHO
                var index_remover = props.props.prods_car.indexOf(id)
                props.props.prods_car.splice(index_remover, 1)
                i = i -1
            }
        }
        catch{
            console.log('erro')
        }
    }

    for(i = 0; i<props.props.prods_car.length; i++){  // PARA CADA ITEM NA LISTA DE NOMES DE PRODUTOS NO CARRINHO
        try{
            if(props.props.car[i]['id'] === id_produto){  // ENCONTRA O ITEM NA LISTA DE DETALHES
                produto = props.props.car[i][id_produto]  // E PEGA OS DETALHES
                carrinho = produto.carrinho
                break
            }
        }
        catch{
            break
        }
    }

    function add_to_cart(info){  // FUNÇÃO QUE ADICIONA OS ITENS NO CARRINHO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Comprar' DESSE COMPONENTE
        
        var input = info + 'input'  // APARECE O INPUT DE NUMERO
        document.getElementById(input).classList.remove('d-none')
        
        var carrinho = info + 'carrinho'  // E SOME O BOTÃO DE CARRINHO
        document.getElementById(carrinho).classList.add('d-none') 
            
        done(info)  // VAI PARA A FUNÇÃO DE DEFINIR QUANTIDADE
    }
    
    async function done(info){ // DEFINE A QUANTIDADE
        // FUNÇÃO CHAMADA NA FUNÇÃO 'add_to_cart' DESSE COMPONENTE -> COM A QUANTIDADE 1
        // FUNÇÃO CHAMADA NA ALTERAÇÃO DE VALOR DO INPUT DE NÚMERO DESSE COMPONENTE -> COM A QUANTIDADE ESTABELECIDA PELO USUÁRIO 
        
        var input = info + 'input'

        if (document.getElementById(info + 'quantidade_numero')){ // BUSCA O ITEM NO CARRINHO (ABA LATERAL DIREITA)
            document.getElementById(info + 'quantidade_numero').classList.add('d-none')  // SOME O NÚMERO
            document.getElementById(info + 'loader').classList.remove('d-none')  // APARECE O LOADER
        }
        var num = document.getElementById(input).children[0].value  // PEGA O VALOR SELECIONADO PELO CLIENTE
    
        if ((num === '') || (num === 0)){  // SE FOR VAZIO OU ZERO, DEFINE COMO 1
            num = 1
            document.getElementById(input).children[0].value = num
            props.props.prods_car.push(info)  // E ADICIONA NA LISTA DE PRODUTOS COMPRADOS

            var dict_final = {'id': info}  // CRIA O DICIONÁRIO COM AS INFORMAÇÕES DO PRODUTO PARA MANDAR PRO DB
            dict_final[info] = {'carrinho': 1, 'preco': props.props.props.props.preco, 'estoque': props.props.props.props.estoque, 'img': props.props.props.props.img}
            props.props.car.push(dict_final)
            
        }
        
        if (parseInt(num) > props.props.props.props.estoque){  // VERIFICA SE O NÚMERO É MAIOR DO QUE O ESTOQUE
            num = props.props.props.props.estoque  // SE FOR, NÃO PERMITE O AUMENTO
        }
        
        var id_produto = info
        for(var i = 0; i<props.props.prods_car.length; i++){  // ENCONTRA O PRODUTO NA LISTA DE NOMES DE PRODUTOS NO CARRINHO
            if(props.props.car[i]['id'] === id_produto){
                var produto = props.props.car[i][id_produto]
                produto.carrinho = num
                break
            }
        }

        var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // E ADICIONA AS INFORMAÇÕES NO DICIONÁRIO
        dict_itens['comprar'] = info
        dict_itens['quantidade'] = num

        // PEGA AS OUTRAS INFORMAÇÕES DO ITEM
        var preco = parseFloat(document.getElementById('preco' + info).innerHTML.split(' ')[1].split(',').join('.'))
        var img = document.getElementById(info).children[0].children[0].src

        var dict_prod = {}
        dict_prod['id'] = info
        
        var dict_detalhes = {}
        dict_detalhes['carrinho'] = num
        dict_detalhes['img'] = img
        dict_detalhes['preco'] = preco

        dict_prod[info] = dict_detalhes

        dict_prod = JSON.stringify(dict_prod)


        if(sessionStorage['comprar']){  // REMOVE O ITEM COM VALOR ANTIGO DA SESSÃO
            var list_itens = sessionStorage['comprar'].split(';')
            list_itens.forEach(function (element, index){
                var item = JSON.parse(element)
                if(item['id'] == info){
                    list_itens.splice(index, 1)
                }
            })
        
            if(list_itens){  // ADICIONA O ITEM COM O VALOR NOVO NA SESSÃO
                if(list_itens.length > 0){
                    var lista_prod = list_itens.join(';') 
                    sessionStorage['comprar'] = lista_prod + ';' + dict_prod          
                }
                else{
                    sessionStorage['comprar'] = dict_prod
                }                 
            }
            else{
                sessionStorage['comprar'] = dict_prod
            }   
        }
        else{
            var lista_prod = ''
            sessionStorage['comprar'] = dict_prod
        }        

        
        if(sessionStorage['login']){  // SE O USUÁRIO ESTIVER LOGADO
            if(!sessionStorage['login'].includes('/')){  // COMO CLIENTE
                var produtos = await api.post('add_session_db',{  // ADICIONA OS ITENS NO DB
                    dict_itens
                }).then((response) => {
                    return response
                })    
                // 'produtos' NÃO RETORNA NADA
            }
        }

        // E CHAMA A FUNÇÃO 'carrinho_de_compras' DO ARQUIVO 'frontend/src/pages/home.js'
        var inicio = await props.callback()

        document.getElementById(info + 'quantidade_numero').innerText = num  // FAZ SUMIR O LOADER E APARECER O NÚMERO NOVO NO CARRINHO (ABA LATERAL DIREITA)
        props.props.prods_car.forEach(function (element){
            if((document.getElementById(element + 'quantidade_numero'))){
                document.getElementById(input).children[0].value = num
                document.getElementById(element + 'quantidade_numero').classList.remove('d-none')
                document.getElementById(element + 'loader').classList.add('d-none')          
            }
        })
    }
    
    async function cancel(info){  // FUNÇÃO QUE TIRA O PRODUTO DO CARRINHO  
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Cancel' DESSE COMPONENTE       

        document.getElementById(info + 'input').children[0].value = "0"  // TRANSFORMA A QUANTIDADE DO ITEM EM ZERO
        document.getElementById(info + 'input').classList.add('d-none')  // SOME O INPUT DE NÚMERO        
        document.getElementById(info + 'carrinho').classList.remove('d-none')  // E APARECE O BOTÃO DE CARRINHO
     
    
        var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // MONTA O DICIONÁRIO PARA SALVAR OS DADOS DE PRODUTOS COMPRADOS NO DB
        dict_itens['comprar'] = info
        dict_itens['quantidade'] = 0
        
        if(sessionStorage['login']){  // SE O USUÁRIO ESTIVER LOGADO
            if(!sessionStorage['login'].includes('/')){  // COMO CLIENTE
                var produtos = await api.post('add_session_db',{  // SALVA OS DADOS NO DB
                    dict_itens
                }).then((response) => {
                    return response
                })    
                // 'produtos' NÃO RETORNA NADA
            }
        }
          
        for(var i = 0; i<props.props.prods_car.length; i++){  // REMOVE O PRODUTO DA LISTA DE IDS
            if(props.props.car[i]['id'] === info){
                var produto = props.props.car[i][info]
                produto.carrinho = 0
                break
            }
        }

        var list_itens = sessionStorage['comprar'].split(';')  // REMOVE O PRODUTO DA SESSÃO
        list_itens.forEach(function (element, index){
            var item = JSON.parse(element)
            if(item['id'] == info){
                list_itens.splice(index, 1)
            }
        })
      
        sessionStorage['comprar'] = list_itens.join(';') 


        var inicio = await props.props.callback()  //  CHAMA A FUNÇÃO 'carrinho_de_compras' DO ARQUIVO 'frontend/src/pages/home.js'       
    }

    function redirect (id){  // FUNÇÃO PARA REDIRECIONAR PARA A PÁGINA DE DETALHES
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO '?' DESSE COMPONENTE

        window.location.href = '/detalhe/?prod=' + id
    }


    
    if(props.props.prods_car.includes(props.props.props.id)){  // SE O ITEM ESTIVER SNO CARRINHO

        return(  // RENDERIZA O INPUT DE NÚMERO E NÃO O BOTÃO DE COMPRAR
            <div class='row px-0 col col-12 fileira-btn-carrinho'>
                <div class="col-3 px-0">
                    <button className="login-pqn my-1" id={props.props.props.id + 'more'} onClick={() => redirect(props.props.props.id)}>
                        <i className="fa fa-question"></i>
                    </button>     
                </div>

                <div class='col-9 px-0' id={props.props.props.id + 'input'}>
                    <input onChange={() => done(props.props.props.id)} type="number" min='1' value={carrinho} max={props.props.props.props.estoque} placeholder='1' class='my-1 num_input px-2'></input>
                    <button className="cancel-pqn my-1 pull-right" id={props.props.props.id + 'cancel'} onClick={() => cancel(props.props.props.id)}>
                        <i className="fa fa-close"></i>
                    </button>                    
                </div>            
                <div class="px-0 col-9 d-none" id={props.props.props.id + 'carrinho'}>
                    <button className="carrinho-pqn my-1 pull-right" onClick={() => add_to_cart(props.props.props.id)}>
                        Comprar
                    </button>                                                  
                </div>
            </div>
        )
    }
    else{  // CASO O ITEM NÃO ESTIVER NO CARRINHO
        return(  // RENDERIZA O BOTÃO DE COMPRAR E NÃO O INPUT DE NÚMERO
            <div class='row px-0 col col-12 fileira-btn-carrinho'>
                <div class="col-3 px-0">
                    <button className="login-pqn my-1" id={props.props.props.id + 'more'} onClick={() => redirect(props.props.props.id)}>
                        <i className="fa fa-question"></i>
                    </button>     
                </div>

                <div class='col-9 px-0 d-none' id={props.props.props.id + 'input'}>
                    <input onChange={() => done(props.props.props.id)} type="number" value={carrinho} min='1' max={props.props.props.props.estoque} placeholder='1' class='my-1 num_input px-2'></input>

                    <button className="cancel-pqn my-1 pull-right" id={props.props.props.id + 'cancel'} onClick={() => cancel(props.props.props.id)}>
                        <i className="fa fa-close"></i>
                    </button>                                                      
                </div>            
                <div class="px-0 col-9" id={props.props.props.id + 'carrinho'}>
                    <button className="carrinho-pqn my-1 pull-right" onClick={() => add_to_cart(props.props.props.id)}>
                        Comprar
                    </button>
                </div>
            </div>
        )
    }
}    


  export default CarrinhoButtonPqn;
  